import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import linkifyHtml from "linkify-html";

@Pipe({
  name: "linkify",
})
export class LinkifyPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string): SafeHtml {
    if (!value) return "";
    const linkified = linkifyHtml(value, {
      target: "_blank",
      rel: "noopener",
      className: "underline font-medium",
    });
    return this.sanitizer.bypassSecurityTrustHtml(linkified);
  }
}
